const start = new Date();
const userLog = [];
export function addUserLog(log) {
    userLog.push({
        date: new Date(),
        log,
    });
}
export function userLogToString() {
    return userLog.map(l => '[' + toRelative(start, l.date) + '] ' + l.log).join('\n');
}
function toRelative(from, to) {
    const totalSeconds = Math.round((to.valueOf() - from.valueOf()) / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = Math.floor(totalSeconds % 60);
    return zeroPad(minutes.toString()) + 'm ' + zeroPad(seconds.toString()) + 's';
}
function zeroPad(s) {
    return s.length === 1 ? '0' + s : s;
}
